var _style, _path, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _polygon, _polygon2, _polygon3, _g2, _g3, _g4, _g5, _g6, _g7, _path2, _path3, _g8, _g9, _g10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 600",
    style: {
      enableBackground: "new 0 0 1000 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#0872B9;}\n\t.st2{fill:#0F5A99;}\n\t.st3{fill:#1872B9;}\n\t.st4{fill:#109194;}\n\t.st5{fill:none;}\n\t.st6{fill:#7757A3;}\n\t.st7{fill:#5E6061;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.1,165.8v2.8c0.4-0.9,0.8-1.9,1.3-2.8H359.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M431.7,96.7h-7.5c-10.5,5.9-20.1,13.1-28.9,21.2h13.6C415.9,109.8,423.5,102.7,431.7,96.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M406.4,120.9h-14.2c-6.5,6.4-12.5,13.4-17.8,20.8H392C396.2,134.4,401,127.4,406.4,120.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M619.7,165.8h20.2c-3.4-7.3-7.4-14.4-11.9-21h-18C613.7,151.5,617,158.5,619.7,165.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M608.4,141.7h17.6c-5.3-7.5-11.3-14.4-17.8-20.8H594C599.3,127.4,604.1,134.4,608.4,141.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390.3,144.7h-18c-4.5,6.6-8.5,13.7-11.9,21h20.2C383.4,158.5,386.6,151.5,390.3,144.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M591.5,117.9H605c-8.7-8.1-18.4-15.2-28.9-21.2h-7.5C576.8,102.7,584.4,109.8,591.5,117.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M587.5,117.9c-7.3-8.1-15.4-15.2-24.1-21.2H550c5.9,6,11.4,13.1,16.5,21.2H587.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M578.8,141.7h26.1c-4.4-7.5-9.4-14.4-14.8-20.8h-21.7C572.2,127.4,575.7,134.4,578.8,141.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M450.3,96.7h-13.4c-8.7,5.9-16.8,13.1-24.1,21.2h20.9C438.9,109.8,444.4,102.7,450.3,96.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M432,120.9h-21.7c-5.4,6.4-10.4,13.4-14.8,20.8h26.1C424.6,134.4,428.1,127.4,432,120.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M393.7,144.7c-3.7,6.6-7,13.7-9.9,21h29.5c2-7.3,4.3-14.3,7-21H393.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M580,144.7c2.7,6.7,5,13.7,7,21h29.5c-2.9-7.3-6.2-14.4-9.9-21H580z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M435.5,120.9c-3.9,6.4-7.5,13.4-10.6,20.8h26.1c1.9-7.4,4-14.3,6.4-20.8H435.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M468.7,96.7h-14.1c-6.3,5.9-12.1,13.1-17.3,21.2h21.1C461.6,109.8,465,102.7,468.7,96.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M563,117.9c-5.2-8.1-11-15.2-17.3-21.2h-14.1c3.7,6,7.1,13.1,10.3,21.2H563z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M554.5,165.8h29.4c-2.1-7.3-4.4-14.4-7.1-21h-26.5C551.8,151.5,553.3,158.5,554.5,165.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M543,120.9c2.4,6.5,4.5,13.5,6.4,20.8h26.1c-3.2-7.5-6.7-14.4-10.6-20.8H543z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M423.6,144.7c-2.7,6.6-5.1,13.7-7.1,21h29.4c1.2-7.3,2.7-14.3,4.3-21H423.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M517,121.5c0.8,6.3,1.5,13.1,2.2,20.2h27.2c-1.9-7.5-4.1-14.4-6.5-20.8h-22.9C516.9,121.1,517,121.3,517,121.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M538.7,117.9c-3.2-8.1-6.8-15.2-10.6-21.2h-15.2c1.3,5.9,2.5,13,3.6,21.2H538.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M519.4,144.7c0.6,6.7,1.1,13.7,1.5,21h30.5c-1.3-7.3-2.7-14.4-4.4-21H519.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M453.2,144.7c-1.6,6.6-3.1,13.7-4.4,21h30.5c0.4-7.3,0.9-14.3,1.5-21H453.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.4,120.9h-22.9c-2.4,6.4-4.6,13.4-6.5,20.8h27.2c0.6-7.1,1.4-13.9,2.2-20.2 C483.4,121.3,483.4,121.1,483.4,120.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M487.4,96.7h-15.2c-3.8,5.9-7.4,13.1-10.6,21.2h22.1C484.9,109.8,486.1,102.7,487.4,96.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.9,144.7c-0.6,6.6-1.1,13.7-1.5,21h35.5c-0.4-7.3-0.9-14.4-1.5-21H483.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M486.4,120.9c-0.8,6.4-1.6,13.4-2.3,20.8h32c-0.7-7.5-1.4-14.4-2.3-20.8H486.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M513.5,117.9c-1.1-8.1-2.3-15.2-3.7-21.2h-19.3c-1.3,5.9-2.6,13.1-3.7,21.2H513.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.7,93.7h6.2c5.6-3.7,11.3-7,17.3-9.7C445.1,86.6,437.2,89.9,429.7,93.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M564.4,93.7h6.2c-7.5-3.9-15.4-7.1-23.5-9.7C553,86.8,558.8,90,564.4,93.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M546.9,93.7h11.9c-9.7-6-20.2-10.6-31.1-13.4C534.4,83.6,540.8,88.1,546.9,93.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M441.5,93.7h11.9c6.1-5.6,12.5-10.1,19.2-13.4C461.7,83.2,451.3,87.7,441.5,93.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M529.7,93.7h12.7c-8.2-7.1-17.2-12.1-26.7-14.8C520.6,82.3,525.3,87.3,529.7,93.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M484.7,78.9c-9.5,2.7-18.4,7.7-26.7,14.8h12.7C475.1,87.3,479.7,82.3,484.7,78.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M507.5,78h-1c1.5,2.3,2.9,5.6,4.2,10c0.5,1.7,1,3.7,1.5,5.7H526C520.3,85.8,514.1,80.3,507.5,78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M493.8,78h-1c-6.6,2.3-12.9,7.7-18.5,15.7h13.8c0.5-2.1,1-4,1.5-5.7C491,83.6,492.4,80.3,493.8,78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M497.6,78c-2.3,2.3-4.4,7.7-6.4,15.7h17.9c-2-8-4.1-13.4-6.4-15.7H497.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.5,168.8h-20.3v-0.2c-1.9,4.3-3.6,8.6-5.1,13.1h21.3C376.6,177.3,378,173,379.5,168.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M646.3,181.7c-1.5-4.4-3.1-8.7-5-12.9h-20.4c1.5,4.2,2.9,8.5,4.1,12.9H646.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M621.8,181.7c-1.2-4.4-2.6-8.7-4.2-12.9h-29.8c1.1,4.2,2.1,8.5,2.9,12.9H621.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409.6,181.7c0.9-4.4,1.8-8.7,2.9-12.9h-29.8c-1.5,4.2-2.9,8.5-4.2,12.9H409.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.5,181.7c0.5-4.4,1.1-8.7,1.8-12.9h-29.7c-1.1,4.2-2.1,8.5-3,12.9H443.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M587.7,181.7c-0.9-4.4-1.9-8.7-3-12.9H555c0.7,4.2,1.3,8.5,1.8,12.9H587.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M553.8,181.7c-0.5-4.4-1.1-8.7-1.8-12.9h-30.9c0.2,4.2,0.4,8.5,0.6,12.9H553.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M478.6,181.7c0.2-4.4,0.4-8.7,0.6-12.9h-30.9c-0.7,4.2-1.3,8.5-1.8,12.9H478.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M518.7,181.7c-0.2-4.4-0.4-8.7-0.6-12.9h-35.8c-0.2,4.2-0.4,8.5-0.6,12.9H518.7z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 334,
    y: 181.7,
    className: "st2",
    width: 332,
    height: 32.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 190.8,
    className: "st0",
    width: 14,
    height: 14
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 381.7,
    y: 190.8,
    className: "st0",
    width: 14,
    height: 14
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 409.3,
    y: 190.8,
    className: "st0",
    width: 14,
    height: 14
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 437,
    y: 190.8,
    className: "st0",
    width: 14,
    height: 14
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 464.6,
    y: 190.8,
    className: "st0",
    width: 14,
    height: 14
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 492.3,
    y: 190.8,
    className: "st0",
    width: 14,
    height: 14
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 520,
    y: 190.8,
    className: "st0",
    width: 14,
    height: 14
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 547.6,
    y: 190.8,
    className: "st0",
    width: 14,
    height: 14
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 575.3,
    y: 190.8,
    className: "st0",
    width: 14,
    height: 14
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 602.9,
    y: 190.8,
    className: "st0",
    width: 14,
    height: 14
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 630.6,
    y: 190.8,
    className: "st0",
    width: 14,
    height: 14
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "902,230.9 99,230.9 81,218.2 919,218.2 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "857.9,448.6 143.1,448.6 127.1,459.9 873.1,459.9 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "901.9,467.4 99.2,467.4 81.2,480.1 918.9,480.1 "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M317.5,373.2h-39.4L267.6,431h-9.5l32.7-176h5.2h3.7h5.5l32.7,176h-10L317.5,373.2z M316.3,365.7l-18.2-101 l-18.5,101H316.3z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M431.8,262.7h-32.7v168.6h-10V262.7h-32.9v-7.5h32.9h10h32.7V262.7z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M570.1,353.2v55.4c0,11.2-8.2,20.4-19,22.4v0.2H513h-0.2h-10v-93v-7.5v-75.6h7.7h2.5h29.4 c12.5,0.2,22.4,10.2,22.4,22.7v37.7c0,7.2-3.5,13.5-8.5,17.7C563.6,337,570.1,344.5,570.1,353.2z M513,262.7v68.1h29.2 c7.5,0,12.5-7.7,12.5-15.2v-37.7c0-7.5-5-15.2-12.5-15.2H513z M559.9,408.6v-55.4c0-7.5-6.5-15-14-15h-3.7H513v85.5h34.4 C554.9,423.8,559.9,416.1,559.9,408.6z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M668.5,423.8v7.5h-53.9h-2.5h-7.7v-176h63.1v7.5h-52.9v70.6h42.6v7.5h-42.6v83H668.5z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M752.3,423.8v7.5h-47.6h-10.2v-7.5V255.3h10.2v168.6H752.3z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M838.9,423.8v7.5h-47.6h-10.2v-7.5V255.3h10.2v168.6H838.9z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M230,262h-37.9c-7.5,0-12.5,8.5-12.5,16v130.7c0,7.5,5,15,12.5,15h22.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M192.1,254.5c-12.5,0-22.7,11-22.7,23.4v130.7c0,12.5,10.2,23.4,22.7,23.4H228v-8.5h-35.9 c-7.5,0-12.5-7.5-12.5-15V277.9c0-7.5,5-16,12.5-16H230v-7.5H192.1z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M96.4,489.9H123c2.4,0,4.2,0.5,5.3,1.5c1.1,1,1.7,2.6,1.7,4.9v3.8c0,0.7-0.1,1.3-0.2,2 c-0.2,0.6-0.4,1.2-0.8,1.7c-0.4,0.5-0.9,0.9-1.7,1.3c-0.7,0.4-1.7,0.6-2.8,0.7c3.8,0.5,5.7,2.6,5.7,6.5v4.2c0,4.3-3.1,6.5-9.2,6.5 H96.4V489.9z M124.3,497.2c0-1.2-0.3-2-0.8-2.3c-0.5-0.4-1.4-0.5-2.6-0.5h-19.1v9.2h19.1c1.2,0,2.1-0.2,2.6-0.6 c0.5-0.4,0.8-1.2,0.8-2.3V497.2z M124.6,511.7c0-1.5-0.3-2.6-0.8-3.1c-0.5-0.6-1.5-0.8-2.8-0.8h-19.1v10.6h19.1 c1.4,0,2.3-0.3,2.8-0.8c0.5-0.6,0.8-1.6,0.8-3.1V511.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M143.5,496.1h4.5v26.8h-4.5V496.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M161.6,496.1h4.5v23.1h20.3v3.7h-24.8V496.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M195.3,496.1h4.5v23.1h20.3v3.7h-24.8V496.1z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M259.7,498.5c0,0.8,0,1.5,0,2.2v22.3H255v-33h4.5l16.1,21.5l15-21.5h5.1v33h-5.1v-22.3c0-0.4,0-1,0.1-1.8 c0-0.8,0.1-1.8,0.2-3.1c-0.8,1.7-1.5,2.9-2,3.6l-12.6,18.4h-1.4l-13.1-17.9c-0.3-0.5-0.7-1-1.1-1.6c-0.4-0.6-0.8-1.4-1.1-2.5 C259.6,496.8,259.7,497.7,259.7,498.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M311.4,499.3c0.2-0.8,0.6-1.5,1-2c0.5-0.5,1.1-0.8,1.9-1c0.8-0.2,1.8-0.3,3-0.3H336c1.2,0,2.2,0.1,3,0.3 c0.8,0.2,1.4,0.5,1.9,1c0.5,0.5,0.8,1.1,1,2c0.2,0.8,0.3,1.8,0.3,3.1v14.1c0,1.2-0.1,2.3-0.3,3.1c-0.2,0.8-0.5,1.5-1,2 c-0.5,0.5-1.1,0.8-1.9,1c-0.8,0.2-1.8,0.3-3,0.3h-18.6c-1.2,0-2.2-0.1-3-0.3c-0.8-0.2-1.4-0.5-1.9-1c-0.5-0.5-0.8-1.1-1-2 s-0.3-1.8-0.3-3.1v-14.1C311.1,501.2,311.2,500.1,311.4,499.3z M337.8,519.2v-19.4h-22.2v19.4H337.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M356,496.1h2.8l20.1,17.9c0.9,0.8,2,2,3.1,3.4c-0.2-1.2-0.3-2.4-0.4-3.5c0-1.1-0.1-2.1-0.1-3.1v-14.7h4.1v26.8 h-2.5l-20.6-18.7c-0.4-0.4-0.8-0.8-1.3-1.2c-0.5-0.4-1-1-1.4-1.8c0.1,1,0.2,2,0.3,2.9c0,1,0.1,1.9,0.1,2.9v15.8H356V496.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M399.8,496.1h4.5v26.8h-4.5V496.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M428.8,522.9h-4.5v-23.2h-12.3v-3.6h29.1v3.6h-12.3V522.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M448.8,499.3c0.2-0.8,0.6-1.5,1-2c0.5-0.5,1.1-0.8,1.9-1c0.8-0.2,1.8-0.3,3-0.3h18.6c1.2,0,2.2,0.1,3,0.3 c0.8,0.2,1.4,0.5,1.9,1c0.5,0.5,0.8,1.1,1,2c0.2,0.8,0.3,1.8,0.3,3.1v14.1c0,1.2-0.1,2.3-0.3,3.1c-0.2,0.8-0.5,1.5-1,2 c-0.5,0.5-1.1,0.8-1.9,1c-0.8,0.2-1.8,0.3-3,0.3h-18.6c-1.2,0-2.2-0.1-3-0.3c-0.8-0.2-1.4-0.5-1.9-1c-0.5-0.5-0.8-1.1-1-2 s-0.3-1.8-0.3-3.1v-14.1C448.5,501.2,448.6,500.1,448.8,499.3z M475.2,519.2v-19.4H453v19.4H475.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M493.5,496.1h21.6c2,0,3.4,0.4,4.3,1.2c0.9,0.8,1.4,2.1,1.4,4v6c0,1.9-0.5,3.2-1.4,4c-0.9,0.8-2.3,1.2-4.3,1.2 h-4l12.3,10.5h-6.7l-10.9-10.5h-7.9v10.5h-4.5V496.1z M497.9,499.6v9.4h15.4c1,0,1.7-0.2,2.2-0.5c0.5-0.3,0.7-1.1,0.7-2.2v-3.9 c0-1.1-0.2-1.8-0.7-2.2c-0.5-0.4-1.2-0.5-2.2-0.5H497.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M533.3,496.1h4.5v26.8h-4.5V496.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M551.9,496.1h2.8l20.1,17.9c0.9,0.8,2,2,3.1,3.4c-0.2-1.2-0.3-2.4-0.4-3.5c0-1.1-0.1-2.1-0.1-3.1v-14.7h4.1 v26.8h-2.5l-20.6-18.7c-0.4-0.4-0.8-0.8-1.3-1.2c-0.5-0.4-1-1-1.4-1.8c0.1,1,0.2,2,0.3,2.9c0,1,0.1,1.9,0.1,2.9v15.8h-4.1V496.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M599.8,499.7v19.4h21v-7.9h-10.9v-3.4h15.3v8.7c0,1.2-0.1,2.3-0.3,3.1s-0.6,1.5-1,2c-0.5,0.5-1.1,0.8-1.9,1 c-0.8,0.2-1.8,0.3-3,0.3h-17.4c-1.2,0-2.2-0.1-3-0.3c-0.8-0.2-1.4-0.5-1.9-1c-0.5-0.5-0.8-1.1-1-2s-0.3-1.8-0.3-3.1v-14.1 c0-1.2,0.1-2.3,0.3-3.1c0.2-0.8,0.6-1.5,1-2c0.5-0.5,1.1-0.8,1.9-1c0.8-0.2,1.8-0.3,3-0.3H619c1.1,0,2.1,0.1,2.9,0.3 c0.8,0.2,1.5,0.5,2,1c0.5,0.5,0.8,1.1,1.1,1.8c0.2,0.8,0.3,1.8,0.3,2.9v0.7l-4.5,0.9v-4H599.8z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M668.2,494.4v9.2H689c1.5,0,2.7,0.1,3.7,0.4c1,0.3,1.8,0.7,2.4,1.3c0.6,0.6,1,1.4,1.2,2.4 c0.2,1,0.4,2.3,0.4,3.7v3.7c0,1.5-0.1,2.8-0.4,3.8c-0.2,1-0.7,1.8-1.2,2.4s-1.4,1-2.4,1.2c-1,0.2-2.2,0.4-3.7,0.4h-19.3 c-1.5,0-2.7-0.1-3.7-0.4c-1-0.2-1.8-0.7-2.4-1.2s-1-1.4-1.3-2.4c-0.3-1-0.4-2.3-0.4-3.8v-0.9l5.1-1.2v5.3h24.6v-9.9h-20.7 c-1.5,0-2.7-0.1-3.7-0.4c-1-0.2-1.8-0.7-2.3-1.2c-0.6-0.6-1-1.4-1.2-2.4c-0.3-1-0.4-2.3-0.4-3.8v-2.9c0-1.5,0.1-2.8,0.4-3.8 c0.3-1,0.7-1.8,1.2-2.4s1.4-1,2.3-1.2c1-0.2,2.2-0.4,3.7-0.4h17.6c1.4,0,2.5,0.1,3.5,0.3c1,0.2,1.8,0.6,2.4,1.2 c0.6,0.6,1.1,1.3,1.4,2.2c0.3,0.9,0.4,2.1,0.4,3.5v0.7l-4.7,1.3v-4.8H668.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M711.7,496.1h25.8v3.6h-21.4v7.5h13.1v3.5h-13.1v8.5h21.6v3.7h-26.1V496.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M748.4,496.1h21.6c2,0,3.4,0.4,4.3,1.2c0.9,0.8,1.4,2.1,1.4,4v6c0,1.9-0.5,3.2-1.4,4c-0.9,0.8-2.3,1.2-4.3,1.2 h-4l12.3,10.5h-6.7l-10.9-10.5h-7.9v10.5h-4.5V496.1z M752.9,499.6v9.4h15.4c1,0,1.7-0.2,2.2-0.5c0.5-0.3,0.7-1.1,0.7-2.2v-3.9 c0-1.1-0.2-1.8-0.7-2.2c-0.5-0.4-1.2-0.5-2.2-0.5H752.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M782.8,496.1h4.8l11.9,22.4l11.3-22.4h4.4l-14,26.8h-3.7L782.8,496.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M823.9,496.1h4.5v26.8h-4.5V496.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M846.5,499.7v19.4h18.6v-6.7l4.5,0.9v3.2c0,1.2-0.1,2.3-0.3,3.1s-0.5,1.5-1,2c-0.5,0.5-1.1,0.8-1.9,1 c-0.8,0.2-1.8,0.3-3,0.3h-15c-1.2,0-2.2-0.1-3-0.3c-0.8-0.2-1.4-0.5-1.9-1s-0.8-1.1-1-2s-0.3-1.8-0.3-3.1v-14.1 c0-1.2,0.1-2.3,0.3-3.1c0.2-0.8,0.6-1.5,1-2c0.5-0.5,1.1-0.8,1.9-1s1.8-0.3,3-0.3h15c1.2,0,2.2,0.1,3,0.3c0.8,0.2,1.4,0.5,1.9,1 c0.5,0.5,0.8,1.1,1,2c0.2,0.8,0.3,1.8,0.3,3.1v2.5l-4.5,0.8v-6.1H846.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M881.4,496.1h25.8v3.6h-21.4v7.5h13.1v3.5h-13.1v8.5h21.6v3.7h-26.1V496.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2350f2652c8c17c16bb50983d11e16ca.svg";
export { ForwardRef as ReactComponent };